import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './RichTextEditor.scss'
import './PostBox.scss'

interface Props {
  text: string
  onChange: (content: string) => void
  readOnly?: boolean
}

export default function RichTextEditor({
  text,
  onChange,
  readOnly = false
}: Props): React.ReactElement {
  return (
    <div className={`PostBox__box overflow-hidden p-0 ${readOnly ? 'read-only' : ''}`}>
      <ReactQuill
        theme="snow"
        value={text}
        onChange={(content, delta, source, editor: any) => {
          if (!readOnly) {
            onChange(content)
          }
        }}
        readOnly={readOnly}
        modules={readOnly ? { toolbar: false } : undefined}
        className="RichTextEditor"
        preserveWhitespace
      />
    </div>
  )
}
